// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__QXh6m","footer":"ReportModalFilter_footer__JeCBD"};